/* 
<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#7687c2">
     <g fill="none" fill-rule="evenodd">
         <g transform="translate(1 1)" stroke-width="2">
             <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
             <path d="M36 18c0-9.94-8.06-18-18-18">
                 <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/>
             </path>
         </g>
     </g>
</svg>
*/
const loadingIndicator = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzOCIgaGVpZ2h0PSIzOCIgc3Ryb2tlPSIjNzY4N2MyIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGNpcmNsZSBzdHJva2Utb3BhY2l0eT0iLjUiIGN4PSIxOCIgY3k9IjE4IiByPSIxOCIvPjxwYXRoIGQ9Ik0zNiAxOEMzNiA4IDI4IDAgMTggMCI+PGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgMTggMTgiIHRvPSIzNjAgMTggMTgiIGR1cj0iMXMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+PC9wYXRoPjwvZz48L3N2Zz4=';


const winOpen = () => {
    const newWin = window.open();
    try {
        const img = new Image();
        img.src = loadingIndicator;
        img.style.margin = '20vh 40vw';
        img.style.width = '20vw';
        newWin.document.write(img.outerHTML);
    } catch (e) {
        console.warn(e);
    }
    return newWin;
}

export default winOpen;